import { createBrowserRouter } from "react-router-dom";
import { SkyStrife } from "./app/SkyStrife";
import { DesignSystem } from "./app/DesignSystem";
import { Amalgema } from "./app/Amalgema";
import { Analytics } from "./app/Analytics";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Amalgema />,
  },
  {
    path: "/match",
    element: <SkyStrife />,
  },
  {
    path: "/design-system",
    element: <DesignSystem />,
  },
  {
    path: "/analytics",
    element: <Analytics />,
  },
]);
